import React, { useState } from "react";
import Star from "../assets/icons/Star";
import Rightarrow from "../assets/icons/Rightarrow";
import { useCart } from "../context/CartContect";
import Modal from "./Modal";
import { getLoginData } from "../utils/loginSession";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const RestaurantMenuCard = ({ restaurant: menuItem }) => {
  const { t } = useTranslation();
  // price
  // check for deals price, discount price,
  const { removeFromCart, addToCart, setDeal, cart,updateOptionInCart } = useCart();
  const [quantity, setQuantity] = useState(0);
  const [inCart, setInCart] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // console.log("Menu Item:", menuItem);

  

  const [options, setOptions] = useState(cart?.find(item => item.product._id === menuItem._id)?.options || []);
  function checkUserLoggedIn  ()  {
    const user = getLoginData()?.user;
    if (!user) {
      toast.success("Please login to continue", {
              position: "bottom-center",
              autoClose: 3000,
            });
      return false;
    }
    return true;
  };
  const handleAddToCart = () => {
    if(!checkUserLoggedIn()) return;
    setInCart(true);
    setQuantity(1);
    addToCart(menuItem, options, quantity + 1);
  };

  const handleIncrement = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
    console.log(`${quantity}`);
    addToCart(menuItem, options, quantity + 1);
  };

  
  const handleDecrement = () => {
    setQuantity((prevQuantity) => {
      if (prevQuantity > 1) {
        // removeFromCart(menuItem._id);
        addToCart(menuItem, options, quantity -1);
        return prevQuantity - 1;
      } else {
        removeFromCart(menuItem._id);
        setInCart(false);
        return 1;
      }
    });
  };


  
  const handleOptionClick = () => {
    checkUserLoggedIn() &&
    setShowModal(true); // Show the modal when 'Option' button is clicked
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close the modal
  };
  // console.log("Options selected:", options);
  

  return (
    <React.Fragment>
      <div className="rest_card rest_menu">
        <div className="rest_img">
          <img src={menuItem.image} alt={menuItem.name} />
          <span className={`rest_${menuItem.isVeg ? "veg" : "nonveg"}`}></span>
        </div>
        <div className="rest_detail">
          <div className="title_flex_menu">
            <p className="rest_name">{menuItem.name}</p>
            {/* <span className="rest_stars">
              <Star />
              {menuItem.rating}
            </span> */}
          </div>
          <p className="rest_desc">{menuItem.description}</p>

          <div className="rest_price_flex">
            <p className="menu_price">€ {menuItem.price}</p>
            {menuItem?.options?.length > 0 && (
              <button className="option_btn" onClick={handleOptionClick}>
                Option
              </button>
            )}
            {inCart ? (
              <div className="quantity_control">
                <button className="quantity_btn" onClick={handleDecrement}>
                  -
                </button>
                <span>{quantity}</span>
                <button className="quantity_btn" onClick={handleIncrement}>
                  +
                </button>
              </div>
            ) : (
              <button className="btn btn-primary" onClick={handleAddToCart}>
                {t('add_to_cart')}
              </button>
            )}
          </div>
        </div>
      </div>
      <Modal show={showModal} onClose={handleCloseModal}>
        <div className="modal-options">
          {menuItem.options.map((group, groupIndex) => (
            <div key={groupIndex}>
              <h3>{group.name}</h3>

              {group.values.map((option, optionIndex) => (
                <div className="option-item" key={optionIndex}>
                  <span>{option.label}</span>
                  <span className="price">€{option.price}</span>

                  <input
                    type={group.type === "single" ? "radio" : "checkbox"}
                    name={`group-${groupIndex}`} 
                     checked= {
                       (group.type === "single" && options.find(o => o.group_id === group._id)?.option_id === option._id)
                       || (group.type !== "single" && options.find(o => o.group_id === group._id)?.option_id.includes(option._id)  )
                      }
                    onChange={(e) => {
                      console.log(e.target.checked,group.type);

                      if(e.target.checked===false){
                        if(group.type==="single"){
                          
                          let updatedOptions = options.filter(o => o.group_id !== group._id);
                          setOptions(updatedOptions);
                          updateOptionInCart(menuItem, updatedOptions);
                        }
                        else{
                          let updatedOptions = options.map(o => {
                            if(o.group_id === group._id){
                              const newOptionIds = o.option_id.filter(id => id !== option._id);
                              const newPrice = (o.price || 0) - option.price;
                              console.log("New Option Ids:", newOptionIds);
                              console.log("New Price:", newPrice);
                              return { ...o, option_id: newOptionIds, price: newPrice };
                            }
                            return o;
                          }).filter(o => o.option_id.length > 0); // Remove group if no options selected
                          setOptions(updatedOptions);
                          updateOptionInCart(menuItem, updatedOptions);
                        }
                        return;

                      }
                      let updatedOptions = [...options];
                      // select case:
                      console.log("Group selected", group);
                      console.log("Option selected", option);

                      const exists = updatedOptions.find(
                          (o) => o.group_id === group._id
                        );

                      if (group.type === "single") {
                        if (exists) {
                          updatedOptions = updatedOptions.map((o) =>
                            o.group_id === group._id
                              ? { ...o, option_id: option._id ,
                              price: option.price

                              }
                              : o
                          );
                        } else {
                          updatedOptions = [
                            ...updatedOptions,
                            {
                              group_id: group._id,
                              option_id: option._id,
                              price: option.price
                            },
                          ];
                        }
                      } else {
                        if (exists) {

                          updatedOptions = updatedOptions.map((o) =>
                            o.group_id === group._id
                              ? { ...o, option_id: [...o.option_id, option._id],
                                price: (o.price || 0) + option.price
                               }
                              : o
                          );
                        }
                        else{
                          updatedOptions = [
                            ...updatedOptions,
                            {
                              group_id: group._id,
                              option_id: [option._id],
                              price: option.price
                            },
                          ];
                        }
                      }

                      console.log("Updated Options:", updatedOptions);
                      setOptions(updatedOptions);
                      updateOptionInCart(menuItem, updatedOptions);
                      // update parent state
                      // setMenuItem({
                      //   ...menuItem,
                      //   options: updatedOptions,
                      // });
                    }}
                  />
                </div>
              ))}
            </div>
          ))}

          {/* {menuItem.options.map((group) => (
            <div>
              <h3>{group.name}</h3>
              {group.values.map((option) => (
                (<div className="option-item">
                  <span>{option.label}</span>
                  <span className="price">€{option.price }</span>
                    <input
                      type={group.type === "single" ? "radio" : "checkbox"}
                      // value="option1"
                      checked={1==2} 
                      // {option.selected}
                       onChange={() => {
                        console.log("Group selected",group); 
                         console.log("option selected",option); 
                       }}
                    />
                    </div>)
              ))}
            
              </div>
          ))} */}
        </div>
      </Modal>
    </React.Fragment>
  );
  
};

export default RestaurantMenuCard;
